export const initialCategories = [
  "Hair, Skin & Nails Supplements",
  "Beauty Supplements",
  "Multivitamins",
  "Women's Health",
  "Vegan Supplements",
  "Daily Wellness",
  "Gummy Vitamins",
  "Vitamins",
  "Gummy Bears",
  "Gummy Candy",
  "Cruelty-Free",
  "Non-GMO",
  "Plant-Based",
];
